import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLocations from '../../reducers/locations/locations.reducer';

export const selectLocationsFeature = createFeatureSelector<
  fromLocations.State
>(fromLocations.locationsFeatureKey);

// INTERFACES
export interface LocationsModel {
  locations: any;
  selectedLocationsFilter: any;
}

// SELECTORS
export const selectLocations = createSelector(
  selectLocationsFeature,
  (state: fromLocations.State): LocationsModel => {
    return {
      locations: state.locations,
      selectedLocationsFilter: state.selectedLocationsFilter
    };
  }
);
